import { PackagePresenter } from "@/presenters/group/package-group/PackagePresenter";

export class PackageGroupPresenter {
  constructor(packageGroup) {
    this.name = packageGroup ? packageGroup.name : "";
    this.packages = packageGroup
      ? packageGroup.packages.map(item => new PackagePresenter(item))
      : [];
    this.isAffectApp = packageGroup.isAffectApp;
    this.deletedAt = packageGroup.deletedAt;
  }
}